import { USER_PLACEHOLDER_IMAGE } from '@lua-frontend/utils'
import { PlayIcon } from '../../assets'
import { SlideContent } from './carousal.types'

export default function SlideImage({ content }: { content: SlideContent }) {
  const imageSource =
    content.mediaType === 'video' ? content.thumbnail : content.mediaUrl

  return (
    <div className='h-inherit flex flex-grow items-center justify-center w-full bg-light-gray'>
      <img
        loading="lazy"

        src={imageSource || ''}
        className="!object-contain"
        onError={() => USER_PLACEHOLDER_IMAGE}
        alt={content.answerText || content.mediaUrl || 'Slider'}
      />

      {content.mediaType === 'video' && (
        <div className="absolute left-[40%] top-[45%]">
          <PlayIcon />
        </div>
      )}
    </div>
  )
}
